import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import classnames from 'classnames'
import { InputForm, InputHidden } from 'controls/Input'
import Button from 'controls/Button'
import { Row, Col } from 'flexbox'
import Switch from 'react-ios-switch'
import { colors } from 'theme'
import RgpdCoponent from 'components/Rgpd'
import { isContentCountry } from 'globalConfigApp'
import PhoneInputForm from 'controls/PhoneInput'
import { companyConfig } from 'globalConfigApp'

import styles from './style'
import { IonIcon } from 'controls'
import { common } from '../styles'


export class ContactForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasExperience: true,
      checkedRgpd: !isContentCountry(['es'])
    }
  }

  toggleExperience = () => {
    this.setState({ hasExperience: !this.state.hasExperience })
  }

  static propTypes = {
    style: PropTypes.object,
    centered: PropTypes.bool
  }

  static defaultProps = {
    style: {},
    centered: false
  }

  render() {
    const { checkedRgpd } = this.state
    const { handleSubmit, invalid, style, centered } = this.props

    return (
      <form
        className="form-container"
        onSubmit={handleSubmit} style={style}>
        <h4>
          <IonIcon
            icon="chatbubbles"
            style={{ fontSize: '20px', color: colors.articBlue , marginRight: '10px' }}
          />Contáctanos ahora
        </h4>
        <p className="legend"> </p>
        <Row>
          <Col xs={6}>
            <Field
              className="form-input-margin"
              name="name"
              id="name"
              component={InputForm}
              placeholder="Nombre"
            />
          </Col>
          <Col xs={6}>
            <Field
              className="form-input-margin"
              name="lastName"
              id="lastName"
              component={InputForm}
              placeholder="Apellido(s)"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              className="form-input-margin"
              name="address"
              id="address"
              component={InputForm}
              placeholder="Dirección"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              className="form-input-margin"
              name="neighborhood"
              id="neighborhood"
              component={InputForm}
              placeholder="Colonia y/o Municipio"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Field
              className="form-input-margin"
              name="city"
              id="city"
              component={InputForm}
              placeholder="Ciudad"
            />
          </Col>
          <Col xs={6}>
            <Field
              className="form-input-margin"
              name="zipCode"
              id="zipCode"
              component={InputForm}
              placeholder="Código Postal"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <p className="label action-switch">
              Tiene experiencia en Bienes Raíces
            </p>
          </Col>
          <Col xs={6}>
            <div className="switch-container">
              <Switch
                pendingOnColor={colors.primary}
                checked={this.state.hasExperience}
                onChange={this.toggleExperience}
              />
              <Field
                name="hasExperience"
                id="hasExperience"
                component={InputHidden}
                currentValue={this.state.hasExperience}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              className="form-input-margin"
              name="email"
              id="email"
              component={InputForm}
              placeholder="Correo Electrónico"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              className="form-input-margin"
              name="telephone"
              id="telephone"
              component={PhoneInputForm}
              placeholder="Teléfono"
            />
          </Col>
        </Row>
        <RgpdCoponent handleValidRgpd={(checkedRgpd) => this.setState({ checkedRgpd })} checkedRgpd={checkedRgpd} />
        <Row>
          <Col xs={12} className="actions">
            <Button
              color="primary"
              fullWidth
              type="submit"
              className="submit"
              disabled={invalid && !checkedRgpd}
            >
              Contactar
            </Button>
            <p className="terms">
              Al hacer clic en "Contactar" estoy de acuerdo con los{' '}
              <span className="terms-link">Términos y Condiciones</span> para
              recibir información de parte de {companyConfig.name}.
            </p>
          </Col>
        </Row>
        <style jsx>{styles}</style>
        <style jsx>{common}</style>
      </form>
    )
  }
}

const formConfig = {
  form: 'ContactForm'
}

export default reduxForm(formConfig)(ContactForm)
